// extracted by mini-css-extract-plugin
export default {"container":"Advertorial_container__v1RLB","body":"Advertorial_body__bHWJq","to":"Advertorial_to__zSLLu","footer":"Advertorial_footer__z9rJN"};